import React, { Fragment } from 'react'
import { Relative, Absolute, Text, Box, Button } from 'rebass'
import ScrollChor from 'react-scrollchor'
import styled from 'styled-components'
import Img from 'gatsby-image'
import { Carousel } from 'react-responsive-carousel'
import styles from 'react-responsive-carousel/lib/styles/carousel.min.css'
import Header from '../header'
import { fonts, colors } from '../../theme'
import PrimaryButton from '../../elements/Button/PrimaryButton'
import SecondaryButton from '../../elements/Button/SecondaryButton'
import Fade from 'react-reveal/Fade'

const ImageOverlay = styled(Absolute)`
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
`
const CoverImageContainer = styled(Relative)`
  overflow: hidden;
`
const CoverImage = styled(Img)`
  height: 90vh;
  object-fit: 'cover';
  transition: all 0.3s linear;
`
const DetailsContainer = styled(Absolute)`
  color: ${colors.white};
  left: 0;
  top: 50%;
  width: 100%;
  z-index: 2;
  line-height: 1.33;
  text-align: center;
  transform: translateY(-50%);

  @media (max-width: 48em) {
    bottom: 40%;
    transform: translateY(50%);
    transition: all 0.3s linear;
  }
`
const Para = styled(Text)`
  width: 100%;
  font-weight: 700;
  line-height: 1.4;
  letter-spacing: 0;
  font-family: ${fonts.primary};
`

const Slideshow = props => (
  <div id="slideshow">
    <Header fullDesign style={{ zIndex: 300 }} />
    <Carousel
      showArrows={true}
      showThumbs={false}
      showStatus={false}
      infiniteLoop={true}
      autoPlay={true}
      interval={8000}
      transitionTime={800}
    >
      <div style={{ marginTop: '60px' }}>
        <Relative>
          <DetailsContainer>
            <Box width={[1]}>
                <Fade left duration={2000}>
              <Para fontSize={[4, 5, 5, 7]} mx={3}>
                  We are your financial
                  <div> solution</div>
              </Para>
                </Fade>
            </Box>
                {/* <video autoPlay>
            <source src="/video/jain.mp4" type="video/mp4" />
          </video> */}
          </DetailsContainer>
          <CoverImageContainer>
            <CoverImage sizes={props.slideshowImage.sizes} />
            <ImageOverlay />
          </CoverImageContainer>
        </Relative>
      </div>
    </Carousel>
  </div>
)

export default Slideshow



// WEBPACK FOOTER //
// ./src/components/home/Slideshow.js